import Cookie from "js-cookie";
import { Storage } from "./index";

/**
 * Cookieの属性
 */
type WithAttributes = { expires: number; path: string };

const withAttributes: WithAttributes = { expires: 30, path: "/" };

export const storage: Storage = {
  /**
   * @param key 値を取り出したいキー
   * @returns Storage オブジェクトのゲッター
   */
  get: (key: string) => Cookie.getJSON(key),
  /**
   * @param key 値を取り出したいキー
   * @param value 値
   * @returns Storage オブジェクトのセッター
   */
  set: (key: string, value: string[]) => Cookie.set(key, value, withAttributes),
};
